export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';
export const USER_SIGNUP_RESET = 'USER_SIGNUP_RESET';

export const USER_UPDATE_PASSWORD_REQUEST = 'USER_UPDATE_PASSWORD_REQUEST';
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS';
export const USER_UPDATE_PASSWORD_FAIL = 'USER_UPDATE_PASSWORD_FAIL';

export const USER_UPDATE_SCORE_REQUEST = 'USER_UPDATE_SCORE_REQUEST';
export const USER_UPDATE_SCORE_SUCCESS = 'USER_UPDATE_SCORE_SUCCESS';
export const USER_UPDATE_SCORE_FAIL = 'USER_UPDATE_SCORE_FAIL';
export const USER_UPDATE_SCORE_RESET = 'USER_UPDATE_SCORE_RESET';

export const USER_UPDATE_STAR_REQUEST = 'USER_UPDATE_STAR_REQUEST';
export const USER_UPDATE_STAR_SUCCESS = 'USER_UPDATE_STAR_SUCCESS';
export const USER_UPDATE_STAR_FAIL = 'USER_UPDATE_STAR_FAIL';
export const USER_UPDATE_STAR_RESET = 'USER_UPDATE_STAR_RESET';

export const USER_GAME_TICKETS_ADD = 'USER_GAME_TICKETS_ADD';
export const USER_GAME_TICKETS_MINUS = 'USER_GAME_TICKETS_MINUS';

export const TEACHER_GET_TESTS_REQUEST = 'TEACHER_GET_TESTS_REQUEST';
export const TEACHER_GET_TESTS_SUCCESS = 'TEACHER_GET_TESTS_SUCCESS';
export const TEACHER_GET_TESTS_FAIL = 'TEACHER_GET_TESTS_FAIL';

export const USER_SKIP_NEWEST = 'USER_SKIP_NEWEST';

export const GET_SCOREBOARD_REQUEST = 'GET_SCOREBOARD_REQUEST';
export const GET_SCOREBOARD_SUCCESS = 'GET_SCOREBOARD_SUCCESS';
export const GET_SCOREBOARD_FAIL = 'GET_SCOREBOARD_FAIL';
export const GET_SCOREBOARD_RESET = 'GET_SCOREBOARD_RESET';

export const GET_STUDENTS_REQUEST = 'GET_STUDENTS_REQUEST';
export const GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS';
export const GET_STUDENTS_FAIL = 'GET_STUDENTS_FAIL';
export const GET_STUDENTS_RESET = 'GET_STUDENTS_RESET';
